import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}
const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/Index.vue'),
		redirect:'/home',
        children: [{
          path: 'home',
          name: 'home',
          component: () => import('../components/home.vue')
        },{
			path: 'overseas',
			name: 'overseas',
			component: () => import('../components/overseas.vue')
		},
        {
          path: 'product',
          name: 'product',
          component: () => import('../components/product.vue')
        },{
          path: 'solution',
          name: 'solution',
          component: () => import('../components/solution.vue')
        },{
          path: 'case',
          name: 'case',
          component: () => import('../components/case.vue')
        },{
          path: 'aboutUs',
          name: 'aboutUs',
          component: () => import('../components/aboutUs.vue')
        }
      ]
    },
	{
		path: '/companyIntro',//微信小程序公司简介
		name: 'companyIntro',
		component: () => import('../components/wechat/companyintro.vue')
	},{
		path: '/wechatcase',//微信小程序经典案例
		name: 'wechatcase',
		component: () => import('../components/wechat/cases.vue')
	},{
		path: '/software',//微信产品展示-软件产品
		name: 'software',
		component: () => import('../components/wechat/software.vue')
	},{
		path: '/satellite',//微信产品展示-卫星数据产品
		name: 'satellite',
		component: () => import('../components/wechat/satellite.vue')
	},{
		path: '/hardware',//微信产品展示-硬件
		name: 'hardware',
		component: () => import('../components/wechat/hardware.vue')
	},{
		path:'/solutionEarth',//微信-信息化系统建设
		name: 'solutionEarth',
		component: () => import('../components/wechat/solutionEarth.vue')
	},{
		path:'/solutionGIS',//微信-GIS数据处理
		name: 'solutionGIS',
		component: () => import('../components/wechat/solutionGIS.vue')
	},{
		path:'/solutionSand',//微信-沙盘制作
		name: 'solutionSand',
		component: () => import('../components/wechat/solutionSand.vue')
	},{
		path:'/solutionSystem',//微信-XR建设
		name: 'solutionSystem',
		component: () => import('../components/wechat/solutionSystem.vue')
	},{
		path:'/solutionVisual',//微信-可视化
		name: 'solutionVisual',
		component: () => import('../components/wechat/solutionVisual.vue')
	}
	
]

const router = new VueRouter({
    // mode:'history',
    routes,
})

export default router
